import { render } from "./PdfCertificacionDeuda.vue?vue&type=template&id=534fff50&scoped=true"
import script from "./PdfCertificacionDeuda.vue?vue&type=script&lang=js"
export * from "./PdfCertificacionDeuda.vue?vue&type=script&lang=js"

import "./PdfCertificacionDeuda.vue?vue&type=style&index=0&id=534fff50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-534fff50"]])

export default __exports__